import React, { useMemo } from 'react'
import styles from 'modules/Services/Network/network.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import SliderBanner from 'components/Banners/SliderBanner'
import { Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import Breadcrumbs from 'components/Breadcrumbs'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import NetworkBalanceColumn from 'modules/Services/Network/subcomponents/NetworkBalanceColumn'
import clsx from 'clsx'

const NetworkItemHeader = ({ title, totallyEmptyList, networkId, networkType, homepage_link }) => {
  const pathGen = useGeneratePathI18n()
  const { t } = useTranslation()
  const breakpoints = useBreakpoint()

  const breadcrumbsConfig = useMemo(
    () => [
      {
        title: t('services::heading'),
        to: pathGen(ROUTES.SERVICES),
      },
    ],
    [networkType, t],
  )

  return (
    <div className={styles['network-item']}>
      <Grid
        justifyContent={'between'}
        direction={'column'}
      >
        <Breadcrumbs
          links={breadcrumbsConfig}
          title={title}
          className={styles['network-item__breadcrumbs']}
        />

        {!totallyEmptyList && (
          <Grid
            alignItems={'start'}
            direction={'column'}
            centered={!breakpoints.lg}
            gap={16}
            className={clsx({
              'margin-bottom-16': !breakpoints.lg,
            })}
          >
            {!breakpoints.lg && (
              <NetworkBalanceColumn
                className={'layout-tile'}
                networkType={networkType}
                homepage_link={homepage_link}
              />
            )}

            <SliderBanner
              placement="network_page"
              network={networkId}
              className={clsx(styles['banner-container'], {
                'margin-bottom-16': breakpoints.lg,
              })}
            />
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default NetworkItemHeader

NetworkItemHeader.propTypes = {
  title: PropTypes.string,
  totallyEmptyList: PropTypes.bool,
  networkId: PropTypes.string,
  networkType: PropTypes.string,
  homepage_link: PropTypes.string,
}
